import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function ProductCategoriesApi(props) {
    return {
        searchList: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/product-categories`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        }
    }
}